import React, { useEffect, useState } from 'react';
import BaseSelector from '../BaseSelector';
import styles from './styles.scss';
import { get, isString, isNumber, isEmpty } from 'lodash';
import { bool, func, shape, string } from 'prop-types';
import { baseSelectorShape, industryShape } from '../../helpers/propTypes';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { showToast } from '../../state/modules/app/notification';
import {
  getCategoriesApi,
  getIndustriesApi,
} from '../../helpers/advertiserApi';
import { modules } from 'veritone-redux-common';
import constant from '../../helpers/constant';

function IndustryCategorization({
  industry,
  onChange,
  industrySelector,
  categorySelector,
  edit,
  error,
  config,
  showToast,
}) {
  const [industries, setIndustries] = useState([]);
  const [isLoadingIndustry, setIsLoadingIndustry] = useState(false);
  const [isLoadingCategory, setIsLoadingCategory] = useState(false);

  const getIndustry = (industryId) => {
    return (
      industries.find((industry) => industry.industryId === industryId) || {}
    );
  };
  const fetchIndustriesData = async () => {
    setIsLoadingIndustry(true);
    const res = await getIndustriesApi(config.urlApi);
    if (res && res.error) {
      const toast = {
        message: 'Fail to fetch list of industry',
        action: 'Dismiss',
        type: constant.FAILED,
      };
      showToast(toast);
    } else {
      const responseIndustries = get(res, 'data.industries', []);
      setIndustries(responseIndustries);
    }
    setIsLoadingIndustry(false);
  };

  const fetchCategoriesData = async (industryId) => {
    const isLoadedCategory = getIndustry(industryId).categories;
    if (!isLoadedCategory) {
      setIsLoadingCategory(true);
      const res = await getCategoriesApi(config.urlApi, industryId);
      if (res && res.error) {
        const toast = {
          message: 'Fail to fetch list of category',
          action: 'Dismiss',
          type: constant.FAILED,
        };
        showToast(toast);
      } else {
        const newIndustries = industries.map((industry) => {
          if (industry.industryId === industryId) {
            return {
              ...industry,
              categories: get(res, 'data.categories', []),
            };
          }
          return industry;
        });

        setIndustries(newIndustries);
      }
      setIsLoadingCategory(false);
    }
  };

  const handleSelectIndustry = async (event) => {
    const { value } = event.target;
    if (isString(value) || isNumber(value)) {
      const selectedIndustry = industries.find(
        (item) => item.industryId === value
      );

      onChange &&
        onChange({
          industryId: value,
          industryName: get(selectedIndustry, 'industryName', ''),
        });

      await fetchCategoriesData(value);
    }
  };

  const handleSelectCategory = (event) => {
    const { value } = event.target;
    if (isString(value) || isNumber(value)) {
      const selectedCategory = categories.find(
        (item) => item.categoryId === value
      );
      onChange &&
        onChange({
          ...industry,
          category: {
            categoryId: value,
            categoryName: get(selectedCategory, 'categoryName', ''),
          },
        });
    }
  };
  
  useEffect(() => {
    !industry && fetchIndustriesData();
  }, []);

  const categories =
    (industry && getIndustry(industry.industryId).categories) || [];
  const onlyShowText = edit && industry && industry.category;

  return (
    <div className={styles.industryCategorizationContainer}>
      <BaseSelector
        {...industrySelector}
        options={industries}
        onSelectFieldChange={handleSelectIndustry}
        value={industry}
        onlyShowText={onlyShowText}
        errorMessage={error.industry}
        loading={isLoadingIndustry}
      />
      <BaseSelector
        {...categorySelector}
        options={categories}
        onSelectFieldChange={handleSelectCategory}
        value={get(industry, 'category')}
        isDisabled={isEmpty(industry)}
        onlyShowText={onlyShowText}
        errorMessage={error.category}
        loading={isLoadingCategory}
      />
    </div>
  );
}

IndustryCategorization.propTypes = {
  industrySelector: baseSelectorShape,
  categorySelector: baseSelectorShape,
  industry: industryShape,
  onChange: func,
  edit: bool,
  error: shape({
    industry: string,
    category: string,
  }),
  showToast: func,
  config: shape({
    urlApi: string,
  }),
};

IndustryCategorization.defaultProps = {
  industrySelector: {
    label: 'Industry',
    labelKey: 'industryName',
    valueKey: 'industryId',
  },
  categorySelector: {
    label: 'Category',
    labelKey: 'categoryName',
    valueKey: 'categoryId',
  },
  error: {},
};

export default connect(
  (state) => {
    const {
      config: { getConfig },
    } = modules;
    return {
      config: getConfig(state),
    };
  },
  (dispatch) => ({
    showToast: compose(dispatch, showToast),
  })
)(IndustryCategorization);
